<template>
	<div class="content">
		<h3>经销商入库统计</h3>
		<div class="item">
			<el-form ref="form" :inline="true" :model="form" label-width="100px">
				<el-form-item label="起始日期">
					<el-date-picker
						v-model="form.value"
						type="date"
						placeholder="选择日期">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="终止日期">
					<el-date-picker
						v-model="form.value"
						type="date"
						placeholder="选择日期">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="经销商层级">
					<el-input v-model="form.username" clearble></el-input>
				</el-form-item>
                <el-form-item label="经销商">
					<el-input v-model="form.username" clearble></el-input>
				</el-form-item>
                <el-form-item label="产品">
					<el-input v-model="form.username" clearble></el-input>
				</el-form-item>
			</el-form>
			<div class="btn">
				<el-button type="primary">统 计</el-button>
			</div>
		</div>
		<div class="item">
			<el-table :data="tableData" border>
				<el-table-column align="center" label="经销商"></el-table-column>
				<el-table-column align="center" label="经销商编号"></el-table-column>
				<el-table-column align="center" label="经销商层级"></el-table-column>
				<el-table-column align="center" label="产品"></el-table-column>
				<el-table-column align="center" label="产品编号"></el-table-column>
				<el-table-column align="center" label="入库托数"></el-table-column>
				<el-table-column align="center" label="入库箱数"></el-table-column>
                <el-table-column align="center" label="入库盒数"></el-table-column>
                <el-table-column align="center" label="折算箱数"></el-table-column>
                <el-table-column align="center" label="折算盒数"></el-table-column>
			</el-table>
			<el-pagination
                background
                @current-change="handleCurrentChange"
                layout="total,prev, pager, next,jumper"
                :total="pageNum"
                :page-size="10">
                </el-pagination>
		</div>
	</div>
</template>

<script>
export default {
	data(){
		return {
			form: {
				username: '',
				name: '',
				value: null
			},
			options: [{
				value: '选项1',
				label: '黄金糕'
				}, {
				value: '选项2',
				label: '双皮奶'
			}],
			tableData: [],
			pageNum:0,
		}
	}
}
</script>

<style scoped>
.title{
  text-align: left;
}
.btn{
	width: 500px;
	margin:0 100px;
}
.el-form--inline .el-form-item{
    width:300px;
}
.el-input {
	width:220px;
}
</style>


// WEBPACK FOOTER //
// src/pages/EnDealerInStoreCount.vue